export const PREVIEW = 0 // 正常查看
export const PREVIEW_ALL = 1 // 查看全部
export const PREVIEW_EDITOR = 2 // 编辑模式下查看全部
